module.exports = __webpack_public_path__ + "static/media/Team 19 - COULOMB.849cc526.jpg";